import React from 'react';
import dashboardStyle from './courseCard.module.css'
import { useNavigate } from 'react-router-dom';
import { Skeleton } from '@mui/material';

const CourseCard = ({ data, isLoading }) => {
    const navigate = useNavigate();

    function formatPercentage(value) {
        return Number.isInteger(value) ? value : value?.toFixed(1);
    }

    // NEW: Function to check if course is refunded
    const isRefunded = (item) => {
        return item.isRefunded || item.orderStatus === "REFUNDED";
    };

    if (isLoading) {
        // Render skeletons while loading
        return (
            <div className={dashboardStyle.dasboardCardStyle}>
                {[...Array(8)].map((_, index) => (
                    <div className={dashboardStyle.courseCardStyle} style={{ border: "none" }} key={index}>
                        <Skeleton variant="rectangular" className={dashboardStyle.imageView} height={150} />
                        <Skeleton variant="text" height={30} width="60%" style={{ margin: '10px 0' }} />
                        <Skeleton variant="text" height={20} width="80%" />
                        <Skeleton variant="rectangular" height={40} width="100%" style={{ marginTop: '10px' }} />
                    </div>
                ))}
            </div>
        );
    }

    return (
        <>
            {data.map((item, index) => (
                <div 
                    className={dashboardStyle.courseCardStyle} 
                    key={index}
                    style={{
                        opacity: isRefunded(item) ? 0.6 : 1,
                        pointerEvents: isRefunded(item) ? 'none' : 'auto',
                        position: 'relative'
                    }}
                >
                    {/* NEW: Refund Badge */}
                    {isRefunded(item) && (
                        <div className={dashboardStyle.refundBadge}>
                            Refunded
                        </div>
                    )}
                    
                    <img
                        src={item.thumbnail[0]}
                        className={dashboardStyle.imageView}
                        alt='Thumbnail'
                    />
                    {
                        item?.courseType === "LIVESTREAM" ? (
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", paddingRight: "8px" }}>
                                <div style={{ color: "rgba(29, 131, 248, 1)", background: "rgba(29, 131, 248, 0.1)", padding: "5px 15px", fontWeight: "600", fontSize: "12px", borderRadius: "16px" }}> • Live</div>
                            </div>
                        ) : (
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", paddingRight: "8px" }}>
                                <div style={{ color: "rgba(29, 131, 248, 1)", background: "rgba(29, 131, 248, 0.1)", padding: "5px 15px", fontWeight: "600", fontSize: "12px", borderRadius: "16px" }}> • Recorded</div>
                            </div>
                        )
                    }

                    <h6>
                        {item.title}
                    </h6>
                    <p>
                        {item.subtitle}
                    </p>
                    <div className={dashboardStyle.lineStyle} />
                    
                    {/* UPDATED: Show different content based on refund status */}
                    {!isRefunded(item) ? (
                        item.totalPercentageCompleted === 0 ? (
                            <div className={dashboardStyle.buttonStyle} onClick={() => {
                                navigate(`/courses/Courses/CourseDetails/CoursesVideos/${item?._id}`)
                                window.scrollTo(0, 0)
                            }}>
                                <span>Watch Lecture</span>
                            </div>
                        ) : (
                            <div className={dashboardStyle.headingStyle} style={{ marginLeft: 10, marginRight: 10 }}>
                                <div className={dashboardStyle.activeButtonStyle} onClick={() => {
                                    navigate(`/courses/Courses/CourseDetails/CoursesVideos/${item?._id}`)
                                    window.scrollTo(0, 0)
                                }}>
                                    <span>Watch Lecture</span>
                                </div>
                                {item?.courseType === "LIVESTREAM" ? (
                                    null
                                ) : (
                                    <div className={dashboardStyle.statusStyle} >
                                        {Math.floor(formatPercentage(item?.totalPercentageCompleted))}% Completed
                                    </div>
                                )}
                            </div>
                        )
                    ) : (
                        // NEW: Show disabled message for refunded courses
                        <div className={dashboardStyle.disabledMessage}>
                            This course has been refunded
                        </div>
                    )}
                    
                    {/* Only show progress bar for non-refunded courses */}
                    {!isRefunded(item) && (
                        <div style={{ height: "2px", width: `${item?.totalPercentageCompleted}%`, background: 'rgba(29, 131, 248, 1)', overflow: "none" }} />
                    )}
                </div>
            ))}
        </>
    )
}

export default CourseCard;